import { createContext, useContext } from "react";

export const BottomHeightContext = createContext({});

export const useBottomHeightContext = () => {
  return useContext(BottomHeightContext);
};
